module.exports = __webpack_public_path__ + "static/media/backchevron.1a66b271.svg";